import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import ContactUs from "./pages/ContactUs";
import AboutUs from "./pages/AboutUs";
import CourseDetailsBanner from "./components/CourseDetails";
import ProtectedRoute from "./utils/ProtectedRoute";
import Login from "./pages/Login/Login";
import StudentDashboard from "./pages/Student/StudentDashboard";
import MainLayout from "./layouts/MainLayout";
import AuthLayout from "./layouts/AuthLayout";
import ResetPassword from "./pages/Login/ResetPassword";
import AllStudentsData from "./pages/Admin/AllStudentsData";
import CommonNavbar from "./pages/Navigation/CommonNavbar";
import HrDataDashboard from "./pages/Admin/HrDataDashboard";
import VideosDashboard from "./pages/Admin/VideosDashboard";
import MaterialsDashboard from "./pages/Admin/MaterialsDashboard";
import AssignmentsDashboard from "./pages/Admin/AssignmentsDashboard";
import StudentVideoDashboard from "./pages/Student/StudentVideoDashboard";

const App = () => {
  return (
    <Router>
      <Routes>
        {/* Routes with Navbar & Footer */}
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/course/:id" element={<CourseDetailsBanner />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/contact-us" element={<ContactUs />} />
        </Route>

        {/* Routes without Navbar & Footer */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="reset-password" element={<ResetPassword />} />
        </Route>

        {/* Protected Routes */}
        <Route
          path="/admin/student-data"
          element={
            <ProtectedRoute role="admin">
              <CommonNavbar />
              <AllStudentsData />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/hr-data"
          element={
            <ProtectedRoute role="admin">
              <CommonNavbar />
              <HrDataDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/videos"
          element={
            <ProtectedRoute role="admin">
              <CommonNavbar />
              <VideosDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/materials"
          element={
            <ProtectedRoute role="admin">
              <CommonNavbar />
              <MaterialsDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/assignments"
          element={
            <ProtectedRoute role="admin">
              <CommonNavbar />
              <AssignmentsDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/student/hr-data"
          element={
            <ProtectedRoute role="student">
              <CommonNavbar />
              <StudentDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/student/videos"
          element={
            <ProtectedRoute role="student">
              <CommonNavbar />
              <StudentVideoDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/student/materials"
          element={
            <ProtectedRoute role="student">
              <CommonNavbar />
              <MaterialsDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/student/assignments"
          element={
            <ProtectedRoute role="student">
              <CommonNavbar />
              <AssignmentsDashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
